import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeValueWriteRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeValue } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type UpdateAttributeValueVariables = {
    typeId: string;
    valueId: string;
    body: AttributeValueWriteRequest;
};

export const useUpdateAttributeValueMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeValue>,
        Error,
        UpdateAttributeValueVariables
    >({
        mutationFn: ({ typeId, valueId, body }) =>
            apiClient.attributeTypes.updateValue(typeId, valueId, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
